import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/styles/tailwind.css";
import "./assets/styles/results.css";

import Landing from './views/Landing';
import Results from './views/Results';
import Favorites from './views/Favorites';

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={Landing}/>
      <Route path="/results/:keywords" exact component={Results} />
      <Route path="/favorites" exact component={Favorites} />
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);


